module.exports = __webpack_public_path__ + "img/about_us_bg.8c3c52d8.png";